import { useQuery } from '@tanstack/react-query';
import { getCurrentSession } from './cash-sessions.api';

/**
 * Devuelve la sesion de caja abierta del usuario, o null. Recarga al
 * focus para detectar si la sesion fue cerrada en otra pestaña.
 */
export function useCurrentSession() {
  return useQuery({
    queryKey: ['cash-session', 'current'],
    queryFn: getCurrentSession,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
